import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SweetAlertWizardService } from '../../services/sweetalert-wizard.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sweetalert-launcher',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="launcher-container">
      <div class="nzf-logo" style="
    padding: 20px;
">
        <a href="https://nzf.org.au" target="_blank" style="
    position: relative;
    display: block;
">
          <img src="assets/nzf.png" alt="NZF Logo" style="
    width: min(200px, 80vw);
    max-width: 200px;
    height: auto;
    position: relative;
    display: block;
    margin: 20px auto;
">
        </a>
      </div>
      <div class="hero-section">
        <div class="hero-content">
          <h1 class="hero-title">Community Contribution Self-Assessment</h1>
          <p class="hero-description">
            Discover your level of community engagement and find your place to contribute to building stronger communities together.
          </p>
          <button 
            type="button" 
            (click)="startAssessment()" 
            class="start-button">
            <svg class="button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12l2 2 4-4"/>
              <circle cx="12" cy="12" r="10"/>
            </svg>
            Start Assessment
          </button>
        </div>
      </div>
      
      <div class="features-section">
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="8.5" cy="7" r="4"/>
                <path d="M20 8v6"/>
                <path d="M23 11h-6"/>
              </svg>
            </div>
            <h3 class="feature-title">Personal Assessment</h3>
            <p class="feature-description">Evaluate your skills, resources, and influence in the community</p>
          </div>
          
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
            <h3 class="feature-title">Level Identification</h3>
            <p class="feature-description">Find your engagement level from Seed to Leadership Layer</p>
          </div>
          
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="8.5" cy="7" r="4"/>
                <path d="M17 11h6"/>
                <path d="M20 8v6"/>
              </svg>
            </div>
            <h3 class="feature-title">Table Assignment</h3>
            <p class="feature-description">Get directed to your appropriate engagement table and opportunities</p>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .launcher-container {
      min-height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, rgb(251 22 54) 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }

    .hero-section {
      text-align: center;
      margin-bottom: 2rem;
      max-width: 600px;
      width: 100%;
    }

    .hero-content {
      background: rgba(255, 255, 255, 0.95);
      padding: 2rem;
      border-radius: 20px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
    }

    .hero-title {
      font-size: clamp(1.5rem, 4vw, 2.5rem);
      font-weight: 700;
      color: #1a202c;
      margin-bottom: 1rem;
      line-height: 1.2;
    }

    .hero-description {
      font-size: clamp(1rem, 2.5vw, 1.125rem);
      color: #4a5568;
      margin-bottom: 2rem;
      line-height: 1.6;
    }

    .start-button {
      background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
      color: white;
      border: none;
      padding: 1rem 2rem;
      border-radius: 50px;
      font-size: clamp(1rem, 2.5vw, 1.125rem);
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      box-shadow: 0 10px 20px rgba(66, 153, 225, 0.3);
      min-height: 44px; /* Touch target size */
    }

    .start-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 15px 30px rgba(66, 153, 225, 0.4);
    }

    .button-icon {
      transition: transform 0.3s ease;
    }

    .start-button:hover .button-icon {
      transform: scale(1.1);
    }

    .features-section {
      max-width: 900px;
      width: 100%;
      padding: 20px;
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
    }

    .feature-card {
      background: rgba(255, 255, 255, 0.95);
      padding: 2rem;
      border-radius: 15px;
      text-align: center;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
      transition: transform 0.3s ease;
    }

    .feature-card:hover {
      transform: translateY(-5px);
    }

    .feature-icon {
      color: #4299e1;
      margin-bottom: 1rem;
      display: flex;
      justify-content: center;
    }

    .feature-title {
      font-size: 1.25rem;
      font-weight: 600;
      color: #1a202c;
      margin-bottom: 0.5rem;
    }

    .feature-description {
      color: #4a5568;
      line-height: 1.5;
    }

    @media (max-width: 768px) {
      .launcher-container {
        padding: 1rem 0.5rem;
      }
      
      .hero-content {
        padding: 1.5rem;
        margin: 0 0.5rem;
      }
      
      .features-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
      }
      
      .feature-card {
        padding: 1.5rem;
      }
      
      .start-button {
        padding: 0.875rem 1.5rem;
        width: 100%;
        max-width: 220px;
      }
    }

    @media (max-width: 480px) {
      .hero-content {
        padding: 1rem;
        border-radius: 15px;
      }
      
      .feature-card {
        padding: 1rem;
        border-radius: 10px;
      }
      
      .hero-section {
        margin-bottom: 1.5rem;
      }
    }

    @media (min-width: 1200px) {
      .launcher-container {
        padding: 2rem;
      }
      
      .hero-section {
        margin-bottom: 4rem;
      }
      
      .hero-content {
        padding: 3rem;
      }
    }
  `]
})
export class SweetAlertLauncherComponent {
  constructor(private sweetAlertWizardService: SweetAlertWizardService, private authService: AuthService) {}

  startAssessment(): void {
    this.sweetAlertWizardService.startWizard();
  }
}